//配置全局访问接口地址
let commonUrl = "";


let baseUrl = {
    commonUrl
}

export default baseUrl